import styled from 'styled-components';

import { rubikTypographyStyles } from '../../../../shared/ui';
import {
  nonSelectableSurfaceStyles,
  tapHighlightResetStyles,
} from '../../../../shared/ui';

export const Section = styled.section.attrs({
  'data-ui': 'raffle-faq-section',
})`
  ${rubikTypographyStyles};
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.surface.base};
  padding: ${({ theme }) => theme.scale.px(30)}
    ${({ theme }) => theme.scale.px(26)} ${({ theme }) => theme.scale.px(41)};
`;

export const Outer = styled.div`
  display: grid;
  justify-items: center;
  gap: ${({ theme }) => theme.scale.px(20)};
`;

export const Heading = styled.h2`
  margin: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.scale.px(23)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const List = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.scale.px(339)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(12)};
`;

export const Toggle = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  border: 0;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;

export const Summary = styled.label`
  ${tapHighlightResetStyles};
  ${nonSelectableSurfaceStyles};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.scale.px(16)};
  min-height: ${({ theme }) => theme.scale.px(32)};
  cursor: pointer;
`;

export const Question = styled.span`
  max-width: ${({ theme }) => theme.scale.px(256)};
  font-size: ${({ theme }) => theme.scale.px(14)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(15)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const IconWrap = styled.span`
  position: relative;
  flex-shrink: 0;
  display: block;
  width: ${({ theme }) => theme.scale.px(14)};
  height: ${({ theme }) => theme.scale.px(14)};
  color: #5f5f64;
`;

export const PlusIcon = styled.svg`
  position: absolute;
  top: ${({ theme }) => theme.scale.px(1)};
  left: 0;
  display: block;
  width: ${({ theme }) => theme.scale.px(14)};
  height: ${({ theme }) => theme.scale.px(14)};
`;

export const MinusIcon = styled.svg`
  position: absolute;
  top: ${({ theme }) => theme.scale.px(7)};
  left: 0;
  display: block;
  width: ${({ theme }) => theme.scale.px(14)};
  height: ${({ theme }) => theme.scale.px(2)};
`;

export const Panel = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  margin-top: 0;
  transition: grid-template-rows 280ms cubic-bezier(0.22, 1, 0.36, 1),
    margin-top 280ms cubic-bezier(0.22, 1, 0.36, 1);
`;

export const PanelInner = styled.div`
  overflow: hidden;
`;

export const Answer = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(4)};
  max-width: ${({ theme }) => theme.scale.px(264)};
  opacity: 0;
  transform: translateY(${({ theme }) => theme.scale.px(-8)});
  transition: opacity 220ms ease, transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
`;

export const Paragraph = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(14)};
  line-height: ${({ theme }) => theme.scale.px(15)};
  color: ${({ theme }) => theme.colors.text.subdued};
`;

export const Item = styled.div`
  position: relative;
  overflow: hidden;
  border: ${({ theme }) => theme.scale.px(1)} solid #dedede;
  border-radius: ${({ theme }) => theme.scale.px(15)};
  background: #f8f8fb;
  padding: ${({ theme }) => theme.scale.px(17)};
  min-height: ${({ theme }) => theme.scale.px(68)};
  box-sizing: border-box;

  & > ${Toggle}:checked + ${Summary} + ${Panel} {
    grid-template-rows: 1fr;
    margin-top: ${({ theme }) => theme.scale.px(10)};
  }

  &
    > ${Toggle}:checked
    + ${Summary}
    ${PlusIcon},
    &
    > ${Toggle}:not(:checked)
    + ${Summary}
    ${MinusIcon} {
    display: none;
  }

  & > ${Toggle}:checked + ${Summary} + ${Panel} ${Answer} {
    opacity: 1;
    transform: translateY(0);
  }
`;
